import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

const DragAndDrop = ({
  uploadedFile,
  setUploadedFile,
  error,
  setError,
  additionalClassNames
}) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      let file = acceptedFiles[0];

      if (
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/png"
      ) {
        setError("File type not supported! Please upload an image.");
        return;
      }
      if (file.size > 10485760) {
        setError("File size is too big!");
        return;
      }
      setUploadedFile(file);
      setError("");
    },
    [setUploadedFile, setError]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop
  });

  return (
    <>
      <div
        {...getRootProps()}
        className={" " + (additionalClassNames ? additionalClassNames : "")}
      >
        <input {...getInputProps()} accept="image/png, image/gif, image/jpeg" />
        <div className="mt-1 sm:mt-0 sm:col-span-2">
          <div className="h-[76px] relative flex justify-center items-center px-3 py-2 border-2 border-primary border-dashed rounded-md">
            <div className="space-y-1 text-center">
              {isDragActive ? (
                <p className="text-xs text-gray-500 text-xs">
                  Drop the file here...
                </p>
              ) : (
                <>
                  <div className="flex text-sm text-gray-600">
                    {uploadedFile ? (
                      <>
                        {" "}
                        <label
                          htmlFor="file-upload"
                          className="relative text-primary cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                        >
                          Chosen file: {uploadedFile.name}
                        </label>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={2.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-primary cursor-pointer absolute top-2 right-2"
                          onClick={() => setUploadedFile(null)}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </>
                    ) : (
                      <div className="flex flex-col justify-center items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={2}
                          stroke="currentColor"
                          className="w-6 h-6 text-primary mb-2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                          />
                        </svg>

                        <div className="flex items-center">
                          <p className="pl-1 block text-xs pt-0.5">
                            Drag and Drop or
                          </p>
                          <label
                            htmlFor="file-upload"
                            className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                          >
                            <span className="text-[#08792A] underline ml-2 text-xs">
                              Browse File
                            </span>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <p className="text-xs text-gray-500">
                    {uploadedFile ? "Drop file or click to change it" : ""}
                  </p>
                </>
              )}
            </div>
          </div>
          {error && (
            <p className="text-xs text-red-600 text-center mt-3">{error}</p>
          )}
        </div>
      </div>
    </>
  );
};

export default DragAndDrop;
